import { useTranslation } from 'react-i18next';

import { useMediaQuery } from 'usehooks-ts';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';

import playerAScoreBg from './assets/player-a-score.png?format=webp;avif&as=picture';
import playerBScoreBg from './assets/player-b-score.png?format=webp;avif&as=picture';
import versusBorders from './assets/versus-borders.png?format=webp;avif&as=picture';

import './score-styles.scss';

interface IScoreProps {
  playerAWins: number;
  playerBWins: number;
}

export const Score = ({ playerAWins, playerBWins }: IScoreProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { t } = useTranslation();
  return (
    <div className="flex w-full min-w-40 items-center justify-between gap-3 sm:max-w-[385px] lg:max-w-none">
      <div className="relative mr-[-12px] flex h-9 w-full min-w-9 items-center justify-center sm:h-[89px] sm:w-[112px] lg:max-h-[108px] lg:w-full lg:max-w-[155px]">
        <OptimizedImage
          imageData={playerAScoreBg}
          alt="player-a-score-bg"
          className="absolute left-0 top-0 h-[36px] w-full sm:h-[89px] lg:w-full lg:max-w-[155px]"
          imgStyle={{ objectFit: 'fill' }}
        />

        <span className="score-player-a-gradient-title z-2 relative text-[32px] sm:text-[80px]">
          {`${playerAWins}`}
        </span>
      </div>
      <div className="relative flex w-[60px] items-center justify-center sm:w-[126px] lg:w-[127px]">
        {!isMobile && (
          <OptimizedImage
            imageData={versusBorders}
            alt="versus-borders"
            className="absolute left-1/2 top-1/2 w-[127px] -translate-x-1/2 -translate-y-1/2 object-contain"
          />
        )}
        <div className="flex h-[36px] w-9 items-center justify-center rounded-[50%] border border-[#202066] bg-[#01001D4D] text-base font-bold text-white sm:h-[99px] sm:w-[99px] sm:text-[40px] lg:h-[91px] lg:w-[91px] lg:text-[48px]">
          {t('common.vs')}
        </div>
      </div>
      <div className="relative ml-[-12px] flex h-9 w-full min-w-9 items-center justify-center sm:h-[89px] sm:w-[112px] lg:max-h-[108px] lg:w-full lg:max-w-[155px]">
        <OptimizedImage
          imageData={playerBScoreBg}
          alt="player-a-score-bg"
          className="absolute left-0 top-0 h-[36px] w-full sm:h-[89px] lg:w-full lg:max-w-[155px]"
          imgStyle={{ objectFit: 'fill' }}
        />
        <span className="score-player-b-gradient-title z-2 relative text-[32px] sm:text-[80px]">
          {`${playerBWins}`}
        </span>
      </div>
    </div>
  );
};
